import React, { useState } from "react"
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import { SingleEvent, RecurringEvent } from "icons";
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from 'storybookComponents/Button';
import Selector from 'components/selector.js'
import { Collapse } from "reactstrap";
import Picker from "storybookComponents/Picker";
import Tooltip from "storybookComponents/Tooltip"
import moment from "moment"

const styles = () => ({
  iconRoot: {
    padding: 0,
    "&:hover path": {
      stroke: "#26bbed"
    },
  },
  menuroot: {
    boxShadow: 'none',
    background: "transparent",
    padding: 0,
    width: "360px",
    border: "none",
    marginLeft: 33,
    maxHeight: 447,
    overflow: 'visible',
    top: "395px !important",
  },
  list: {
    marginTop: "14px",
    padding: '4px 0px',
    border: '1px solid #dadada',
    background: "white",
    width: 360,
    borderRadius: 5,
  },
  arrow: {
    height: 12,
    width: 12,
    transform: 'rotate(45deg)',
    border: '1px solid #dadada',
    position: 'absolute',
    top: -7,
    right: 30,
    borderRadius: 2,
    background: 'white',
    borderBottom: 0,
    borderRight: 0
  },
  bodyContainer: {
    padding: "20px 20px 24px 20px",
    fontFamily: "Open Sans !important"
  },
  header: {
    fontSize: 16,
    lineHeight: '24px',
    color: "rgba(51, 51, 51, 0.75)",
    fontWeight: 600,
    marginBottom: 12
  },
  button: {
    height: 32,
    padding: "6px",
    lineHeight: "20px",
    fontSize: 14,
    textTransform: 'none',
    marginTop: 8,
    width: "100%",
    maxWidth: "100%",
    marginBottom: 4
  },
  radioFormControlRoot: {
    marginLeft: 0,
    marginBottom: 16
  },
  radioRoot: {
    padding: 0,
    paddingRight: 10
  },
  marginClass: {
    marginTop: 8
  },
  select_root: {
    border: "none",
    borderBottom: "1px solid #dadada",
    width: '290px',
    paddingLeft: 4
  },
  marginTop: {
    marginTop: 24
  },
  endContainer: {
    position: 'relative'
  },
  endDateContainer: {
    position: 'absolute',
    width: 205,
    top: -8,
    right: 0
  },
  disabledClass: {
    pointerEvents: "none",
    opacity: 0.5
  },
  dayContainer: {
    width: 32,
    height: 32,
    fontSize: 14,
    lineHeight: "20px",
    background: '#f9f9f9',
    marginTop: 16,
    marginRight: 12,
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover": {
      // background: "rgba(38, 187, 237, 0.1)",
      // fontWeight: 600,
      color: "#26BBED"
    }
  },
  selectedDay: {
    background: "rgba(38, 187, 237, 0.1)",
    fontWeight: 600,
    color: "#26BBED"
  },
  flexBox: {
    display: 'flex',
    alignItems: "center"
  }
})

const repeatOptions = [
  {
    id: 'daily',
    label: 'Daily'
  },
  {
    id: 'weekly',
    label: 'Weekly'
  }
]

const weekDaysParse = {
  'Sun': 'S',
  'Mon': 'M',
  'Tue': 'T',
  'Wed': 'W',
  'Thu': 'T',
  'Fri': 'F',
  'Sat': 'S'
}


const fullNameOfWeeks = {
  'Sun': 'Sunday',
  'Mon': 'Monday',
  'Tue': 'Tuesday',
  'Wed': 'Wednesday',
  'Thu': 'Thursday',
  'Fri': 'Friday',
  'Sat': 'Saturday'
}



const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',]


const MenuComponent = ({ classes, setValues, values, timezoneString }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [recurringEventType, setRecurringEventType] = useState(values.recurringEventType || 'non_recurring');
  const [repeatType, setRepeatType] = useState()
  const [recurrenceType, setRecurrenceType] = useState(values.recurrenceType || "never");
  const [date, setDate] = React.useState(values.recurrenceEndDate);
  const [days, setDays] = React.useState(values.recurringDaysList ? values.recurringDaysList.split(',') : ['Mon'])

  React.useEffect(() => {
    let repeatType = repeatOptions.find(e => e.id == (values.repeatType || 'daily'));
    setRepeatType(repeatType)
    let currentDate = new moment().tz(timezoneString);
    currentDate.add(1, 'M')
    setDate(currentDate)
  }, [1])



  const openMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchorEl(null);
  };


  const handleDoneClick = () => {
    let sortedDays = [];
    for (let i = 0; i < weekDays.length; i++) {
      if (days.includes(weekDays[i])) {
        sortedDays.push(weekDays[i])
      }
    }
    let valuesObj = {
      recurringEventType: recurringEventType,
      repeatType: null,
      recurrenceType: null,
      recurringDaysList: null,
      recurrenceEndDate: null
    }
    if (recurringEventType !== "non_recurring") {
      valuesObj.repeatType = repeatType.id;
      valuesObj.recurrenceType = recurrenceType;
      if (repeatType.id == "weekly") {
        valuesObj.recurringDaysList = sortedDays.toString()
      }
      if (recurrenceType !== "never") {
        valuesObj.recurrenceEndDate = date.toISOString()
      }
    }
    setValues({
      ...values,
      ...valuesObj
    })
    closeMenu()
  }

  const handleTypeChange = (e) => {
    setRecurringEventType(e.target.value)
  }

  const handleRepeatOptionChange = (e) => {
    setRepeatType(e)
  }

  const handleRecurrenceEndsValue = (e) => {
    setRecurrenceType(e.target.value)
  }

  const handleSelectDay = (day) => {
    if (days.includes(day)) {
      let remaingDays = days.filter(e => e !== day)
      if (remaingDays.length == 0) {
        return
      }
      setDays(remaingDays)
    } else {
      setDays([...days, day])
    }
  }

  const handleDateChange = (date) => {
    setDate(date)
  }

  const renderDay = (item, index) => (
    <div key={index} className={`${classes.dayContainer} ${days.includes(item) ? classes.selectedDay : ''}`} onClick={handleSelectDay.bind(this, item)}>
      {weekDaysParse[item]}
    </div>
  )


  const getTooltipMessage = () => {
    if (values.recurringEventType == "non_recurring") {
      return "One time event"
    }
    let message;
    let timeMessage = "";
    if (values.recurrenceType !== 'never') {
      timeMessage = ' until ' + moment(values.recurrenceEndDate).format("MMM DD, YYYY")
    }

    if (values.repeatType == 'daily') {
      message = 'Repeats everyday'
    } else {
      let days = values.recurringDaysList.split(',');
      let fullDays = days.map(e => {
        return fullNameOfWeeks[e]
      })
      if (fullDays.length == 7) {
        message = 'Repeats everyday'
      } else {
        if (fullDays.length == 1) {
          message = `Repeats every ${fullDays[0]}`
        } else {
          let _days = fullDays.slice(0, fullDays.length - 1);
          message = `Repeats every ${_days.join()} and ${fullDays[fullDays.length - 1]}`
        }
      }
    }
    return message + timeMessage;
  }

  return (
    <>
      <IconButton
        onClick={openMenu}
        aria-controls='macros-menu'
        classes={{
          root: classes.iconRoot
        }}>
        <Tooltip tooltip_text={getTooltipMessage()} placement="bottom">
          {values.recurringEventType == 'non_recurring' ?
            <SingleEvent /> :
            <RecurringEvent />
          }
        </Tooltip>
      </IconButton>
      <Menu
        id='macros-menu'
        anchorEl={menuAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        getContentAnchorEl={null}
        open={Boolean(menuAnchorEl)}
        onClose={() => { }}
        classes={{
          paper: classes.menuroot,
          list: classes.list
        }}
      >
        <div>
          <div className={classes.arrow}></div>
          <div className={classes.bodyContainer}>
            <div className={classes.header}>Select your event type</div>
            <RadioGroup name="recurringEventType" value={recurringEventType} onChange={handleTypeChange}>
              <FormControlLabel
                classes={{
                  root: classes.radioFormControlRoot,
                }}
                value="non_recurring"
                control={<Radio classes={{ root: classes.radioRoot }} />}
                label="One-time"
              />
              <FormControlLabel
                classes={{
                  root: classes.radioFormControlRoot,
                }}
                value="recurring"
                control={<Radio classes={{ root: classes.radioRoot }} />}
                label="Recurring" />
            </RadioGroup>
            <Collapse isOpen={recurringEventType == 'recurring'}>
              <div className={classes.marginClass}>
                <div className={classes.header}>Repeat</div>
                <Selector value={repeatType} options={repeatOptions} onChange={handleRepeatOptionChange} className={{
                  select_root: classes.select_root
                }}
                />
                <Collapse isOpen={(repeatType && repeatType.id) == 'weekly'}>
                  <div className={classes.flexBox}>
                    {weekDays.map(renderDay)}
                  </div>
                </Collapse>
                <div className={`${classes.header} ${classes.marginTop}`}>Recurrence ends</div>
                <RadioGroup name="recurrenceType" value={recurrenceType} onChange={handleRecurrenceEndsValue}>
                  <FormControlLabel
                    classes={{
                      root: classes.radioFormControlRoot,
                    }}
                    value="never"
                    control={<Radio classes={{ root: classes.radioRoot }} />}
                    label="Never" />
                  <div className={classes.endContainer}>
                    <FormControlLabel
                      classes={{
                        root: classes.radioFormControlRoot,
                      }}
                      value="ends_on"
                      control={<Radio classes={{ root: classes.radioRoot }} />}
                      label="Ends on" />
                    <div className={`${classes.endDateContainer} ${recurrenceType != "ends_on" ? classes.disabledClass : ""}`}>
                      <Picker format={true} type="date" icon={true} handleChange={handleDateChange} defaultValue={date} />
                    </div>
                  </div>
                </RadioGroup>
              </div>
            </Collapse>
            <Button className={classes.button} onClick={handleDoneClick}>Done</Button>
          </div>
        </div>
      </Menu>
    </>
  )
}

export default withStyles(styles)(MenuComponent)